import { render } from "./proposaldetailscheck.vue?vue&type=template&id=fa0971ea&scoped=true"
import script from "./proposaldetailscheck.vue?vue&type=script&lang=js"
export * from "./proposaldetailscheck.vue?vue&type=script&lang=js"

import "./proposaldetailscheck.vue?vue&type=style&index=0&id=fa0971ea&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0971ea"]])

export default __exports__